import React from "react";
import { Button, Grid, TextField, Typography } from "@material-ui/core";
import { Formik } from "formik";
import * as Yup from "yup";
import IconButton from "@material-ui/core/IconButton";
import Folder from "@material-ui/icons/Folder";
import ParkingService from "../../../services/parking.service";
import { useAlert } from "react-alert";
import PulseLoader from "react-spinners/PulseLoader";
import { colors } from "../../../assets/theme";
import { constantsApp } from "../../../constants/constants.app";

const parkingSchema = Yup.object().shape({
  spotNumber: Yup.string().required(
    constantsApp.components.forms.partner.parking.parkingSchema.REQUIRED
  ),
  ownershipCertificate: Yup.mixed().required(
    constantsApp.components.forms.partner.parking.parkingSchema.REQUIRED
  ),
  picture: Yup.mixed().required(
    constantsApp.components.forms.partner.parking.parkingSchema.REQUIRED
  )
});

const communityParkingSchema = Yup.object().shape({
  spotNumber: Yup.string().required("Required field"),
  picture: Yup.mixed().required("A file is required")
});

const partnerInitialValues = { spotNumber: "", ownershipCertificate: "", picture: "" };
const communityInitialValues = { spotNumber: "", picture: "" };

const CreateParkingForm = ({ initialValues, validationSchema, onCancel, onSubmit, askForDocument, formName }) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, props) => {
        onSubmit(values, props);
      }}
    >
      {({
        errors,
        handleChange,
        handleSubmit,
        values,
        setFieldValue,
        isSubmitting
      }) => {
        if (isSubmitting)
          return (
            <Grid
              container
              justify="center"
              alignItems="center"
              style={{ height: 200 }}
            >
              <PulseLoader color={colors.LOADING} />
            </Grid>
          );
        return (
          <form onSubmit={handleSubmit}>
            <Grid container direction="row" spacing={6}>
              <Grid item>
                <Grid
                  container
                  style={{
                    alignItems: "center"
                  }}
                >
                  <input
                    onChange={event => {
                      setFieldValue("picture", event.currentTarget.files[0]);
                    }}
                    id="picture"
                    type="file"
                    style={{ display: "none" }}
                  />
                  <Typography variant="h5" color="secondary">
                    {values.picture !== ""
                      ? values.picture.name
                      : constantsApp.components.forms.partner.parking.textField
                          .UPLOAD_IMAGE}
                  </Typography>
                  <label htmlFor="picture">
                    <IconButton color="secondary" component="span">
                      <Folder />
                    </IconButton>
                  </label>
                </Grid>
                {errors && errors.picture}
              </Grid>
              { askForDocument &&
              <Grid item>
                <Grid
                  container
                  style={{
                    alignItems: "center"
                  }}
                >
                  <input
                    onChange={event => {
                      setFieldValue(
                        "ownershipCertificate",
                        event.currentTarget.files[0]
                      );
                    }}
                    id="ownershipCertificate"
                    type="file"
                    style={{ display: "none" }}
                  />
                  <Typography variant="h5" color="secondary">
                    {values.ownershipCertificate !== ""
                      ? values.ownershipCertificate.name
                      : constantsApp.components.forms.partner.parking.textField
                          .UPLOAD_CERTIFICATE}
                  </Typography>

                  <label htmlFor="ownershipCertificate">
                    <IconButton color="secondary" component="span">
                      <Folder />
                    </IconButton>
                  </label>
                </Grid>
                {errors && errors.ownershipCertificate}
              </Grid>}
            </Grid>

            <TextField
              id="spotNumber"
              onChange={handleChange}
              value={values.spotNumber}
              variant="outlined"
              margin="dense"
              fullWidth
              type="number"
              label={
                constantsApp.components.forms.partner.parking.textField.SPOT_LBL
              }
              helperText={errors && errors.spotNumber}
            />

            <Grid container justify="center">
              <Button
                onClick={() => {
                  onCancel("showForm");
                  onCancel(formName);
                }}
                variant="contained"
                color="secondary"
                size="large"
              >
                {constantsApp.butons.CANCEL}
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                size="large"
              >
                {constantsApp.butons.DONE}
              </Button>
            </Grid>
          </form>
        );
      }}
    </Formik>
  );
}; 

export const CreateCommunityParking = ({onCancel}) => {
  const alert = useAlert();
  const onSubmit = (values, { setSubmitting, resetForm }) => {
    console.log("VALUES:", values);
    ParkingService.createCommunityParking(values)
      .then(value => {
        setSubmitting(false);
        resetForm(communityInitialValues);
        alert.show("Registro exitoso!", { type: "success" });
      })
      .catch(err => {
        setSubmitting(false);
        alert.show(err.message, { type: "error" });
      });
  };
  return <CreateParkingForm initialValues={communityInitialValues} validationSchema={communityParkingSchema} onCancel={onCancel} onSubmit={onSubmit} askForDocument={false} formName="showFormParking" />
};

export default function CreateParking({ onCancel }) {
  const alert = useAlert();
  const onSubmit = (values, { setSubmitting, resetForm }) => {
    ParkingService.createParking(values)
      .then(value => {
        setSubmitting(false);
        resetForm(partnerInitialValues);
        alert.show("Registro exitoso!", { type: "success" });
      })
      .catch(err => {
        setSubmitting(false);
        alert.show(err.message, { type: "error" });
      });
  };
  return <CreateParkingForm initialValues={partnerInitialValues} validationSchema={parkingSchema} onCancel={onCancel} onSubmit={onSubmit} askForDocument={true} formName="showCreateParkingForm" />
}
